module.exports = __webpack_public_path__ + "static/media/ShareUniversal.3a729222.png";